
import React from 'react';
import { DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface DialogFooterButtonsProps {
  onCancel: () => void;
  onSubmit: (e: React.FormEvent) => void;
}

const DialogFooterButtons: React.FC<DialogFooterButtonsProps> = ({
  onCancel,
  onSubmit
}) => {
  return (
    <DialogFooter>
      <Button
        type="button"
        variant="outline"
        onClick={onCancel}
      >
        Cancel
      </Button>
      <Button
        type="submit"
        onClick={onSubmit}
      >
        Send Invitation
      </Button>
    </DialogFooter>
  );
};

export default DialogFooterButtons;
